import { authErrorHandler } from '@/services/error/authHandler.js';
import { showNotification } from '@/plugins/notification';
import router from "../../router";
export default {
  async fetchOrgTypes({ commit }) {
    const response = await fetch(`/api/organization-types`);
    let data = await response.json();
    commit("setOrgTypes", data);
  },

  async fetchOrgData({ commit }, id) {
    const response = await fetch(`/api/organizations/${id}`);
    let data = await response.json();
    commit("setOrgData", data);
  },

  async fetchOrgList({ commit }, id) {
    const response = await fetch(`/api/organizations`);
    let data = await response.json();
    commit("setOrgList", data);
  },

  async fetchCreateOrg({ commit }, payload) {
    let response;
    if(payload.isProfOrg) {
      response = await fetch(`/api/organizations/professional`, {
        method: "POST",
        body: JSON.stringify({
          isPrivate: payload.isPrivate.value,
          name: payload.name,
          username: payload.username,
          email: payload.email,
          description: payload.description,
          typeId: payload.typeId,
          avatarFileId: payload.avatarFileId,
          terms: payload.terms,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    } else {
      response = await fetch(`/api/organizations`, {
        method: "POST",
        body: JSON.stringify({
          isPrivate: payload.isPrivate.value,
          name: payload.name,
          username: payload.username,
          email: payload.email,
          description: payload.description,
          typeId: payload.typeId,
          avatarFileId: payload.avatarFileId,
          terms: payload.terms,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    }
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
    }
    return response;
  },

  async fetchUpdateOrg({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.orgId}`, {
        method: "PATCH",
        body: JSON.stringify({
          terms: payload.terms
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success!`, 'Org/Group has been created', 7000);
    }
    return response;
  },

  async fetchAddUser({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.orgId}/invite-member`, {
        method: "POST",
        body: JSON.stringify({
          userId: payload.userId,
          role: payload.role.value,
          hidden: payload.hidden
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
      showNotification('success', `Success!`, 'Member has been added', 7000);
    }
    return response;
  },

  async fetchAcceptInvite({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/accept-invitation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success!`, 'Member has been added', 7000);
    }
    return response;
  },

  async fetchDeclineInvite({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/decline-invitation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success!`, 'Decline invitation', 7000);
    }
    return response;
  },

  async fetchCancelInvite({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.id}/cancel-invitation`, {
        method: "POST",
        body: JSON.stringify({
          userId: payload.userId,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    let data = await response.json();
    if(data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success!`, 'Cancel invitation', 7000);
    }
    return response;
  },
}